import React from 'react';
import { Skeleton } from '@mui/material';

import type { Column, Row } from './table.organism';

const skeletonCell = () => React.createElement(Skeleton, { variant: 'text', width: '75%' });

export function createSkeletonTable<T>(
  columns: Column<T>[],
  rowCount = 5
): { columns: Column<T>[]; rows: Row<T>[] } {
  return {
    columns: columns.map((col) => ({
      id: col.id,
      label: col.label,
      widthPercent: col.widthPercent,
      format: skeletonCell,
      noSort: true
    })),
    rows: Array.from({ length: rowCount }, (_, i) => ({
      id: `skeleton-${i}`,
      data: {}
    })) as Row<T>[]
  };
}
